export function isProjectBridgeRunInFlightForResolution(resolution) {
    const resolutionStatus = `${resolution?.status || ""}`.trim().toLowerCase()
    if (resolutionStatus === "processing") return true

    const runStatus = `${resolution?.latestRun?.status || ""}`.trim().toUpperCase()
    if (runStatus !== "RUNNING" && runStatus !== "QUEUED") return false

    const targetOverlapIds = Array.isArray(resolution?.latestRun?.targetOverlapIds)
        ? resolution.latestRun.targetOverlapIds.map(String).filter(Boolean)
        : []
    if (targetOverlapIds.length === 0) return true

    const overlapId = `${resolution?.id || ""}`.trim()
    if (!overlapId) return false
    return targetOverlapIds.includes(overlapId)
}

export function getProjectBridgeProcessingAlertMessage(resolution) {
    if (!isProjectBridgeRunInFlightForResolution(resolution)) return ""

    const runStatus = `${resolution?.latestRun?.status || ""}`.trim().toUpperCase()
    if (runStatus === "QUEUED") return "AI rewrite generation is queued for this schedule."
    return "AI rewrite generation is running for this schedule."
}
